import { Skeleton, Stack } from '@mui/material'

export default function PageSkeleton() {
    return (
        <Stack direction="column" spacing={2}>

            <Skeleton variant="rectangular" sx={styles.cardMax} animation="pulse" />
            
        </Stack>
    )
}

const styles={

    card: {
        flex: 1, 
        height: 150, 
        borderRadius: "4px", 
        backgroundColor: 'primary.light',
        // border: `.5px solid rgba(255, 255, 255, 0.1)`,
        border: `primary.main`,
    },
    cardMax: {
        flex: 1, 
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
        borderRadius: "4px", 
        minHeight: "420px", 
        backgroundColor: "primary.main"
    },

}